import { NextApiResponseBody } from 'types/bolt-api/request'
import { GetTownsResponse } from 'types/towns'
import { POSTAL_CODE } from 'constants/regex'

export const getTowns = async (postalCode: string): Promise<NextApiResponseBody<GetTownsResponse>> => {
  try {
    if (!postalCode) {
      throw new Error(`Postal code is missing`)
    }

    if (!POSTAL_CODE.test(postalCode)) {
      throw new Error(`Invalid postal code format`)
    }

    const res = await fetch(`/api/towns/${postalCode}`, {
      method: 'GET'
    })
    const data: NextApiResponseBody<GetTownsResponse> = await res.json()

    if (res.ok && data.success) {
      return data
    }

    return {
      success: !!data?.success,
      data: data?.data
    }
  } catch (error) {
    return {
      success: false
    }
  }
}
